<template>
  <div v-show="show">
    <div id="layer-return-bg" class="carrot-layer-bg">
        <div id="layer-return-add" class="carrot-layer w-500px  h-500px">
          <div id="addr_wrap" class="addr-wrap h-400px" style="display:none">
            <button type="button" @click="HidePostcode()" class="btn-addr-hide">
              <img src="../img/sub/postcode-close.jpg" id="btnFoldWrap" alt="접기 버튼">
            </button>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
const body = document.getElementsByTagName('body')[0]
export default {
  name: 'vuejs-address',
  props: ['show'],
  data () {
    return {
      postcode: '',
      address: '',
      is_detail: false
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal === true) {
        body.classList.add('overflow')
        this.show = true
        this.ShowPostcode()
      } else {
        body.classList.remove('overflow')
        this.show = false
      }
    }
  },
  mounted () {
    this.ShowPostcode()
  },
  methods: {
    ShowPostcode: function () {
      const elementWrap = document.getElementById('addr_wrap')
      let addrHeight = '0px'
      let me = this
      new window.daum.Postcode({
        oncomplete: function (data) {
          var fullAddr = data.address
          var extraAddr = ''
          if (data.addressType === 'R') {
            if (data.bname !== '') {
              extraAddr += data.bname
            }
            if (data.buildingName !== '') {
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName)
            }
            fullAddr += (extraAddr !== '' ? ' (' + extraAddr + ')' : '')
          }
          me.postcode = data.zonecode
          me.address = fullAddr
          me.$emit('close', true, me.postcode, me.address)
        },
        onresize: function (size) {
          addrHeight = '460px'
          elementWrap.style.height = addrHeight
        },
        width: '100%',
        height: '100%'
      }).embed(elementWrap)
      elementWrap.style.display = 'block'
    },
    HidePostcode: function () {
      let elementWrap = document.getElementById('addr_wrap')
      elementWrap.style.height = '0px'
      setTimeout(function (e) {
        elementWrap.style.display = 'none'
      }, 400)
      this.$emit('close', false)
    }
  }
}
</script>
<style lang="scss" scoped>
#layer-return-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 110;
    &:after{
        position: absolute;
        display: block;
        content: "";
        background: #000;
        opacity: .3;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
    }
}
#addr_wrap{
  position:absolute;
  left:10%;
  width:80%;
  top:50%;
  margin-top:-230px;
  &:after{
    display:block;
    content:"";
    clear: both;
  }
  .btn-addr-hide{
    float:right;
  }
}
@media (min-width: 1024px) {
  #addr_wrap{
    left:50%;
    width:500px;
    margin-left:-250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DaumPostcode.vue